import { openSearchStatesLabels } from 'hooks/openSearchTrucker/types';
import React from 'react';
import { DS_TOKENS } from 'constants/styled.contants';
import GenericState from '../GenericState';

const NotActive = () => (
  <GenericState
    icon="search"
    iconSize="medium"
    iconColor="default"
    title={openSearchStatesLabels.notActive.title}
    message={openSearchStatesLabels.notActive.message}
    testId="desktop-not-active-state"
    marginBottom={DS_TOKENS.spacing.km8}
  />
);

export default NotActive;
